import i18next from 'i18next';
import { Language } from '@moodys/cre-cpm-client-apis.apis.services.auth';

export const translate = (msgKey: string, namespace = 'common'): string => i18next.t(msgKey, {
  ns: namespace,
});

export const convertLocaleToIso = (locale: Language): string => (locale === 'de' ? 'de-DE' : 'en-US');
